import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { BlockingIssuesCallout } from 'modules/integrations/components/SyncButton/Modals/BlockingIssuesModal/BlockingIssueCallout'
import { BlockingIssue } from 'modules/integrations/hooks/SyncContext/blockingIssues'
import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'

type BlockingIssuesModalProps = {
  onClose: () => void
  blockingIssues: BlockingIssue[]
  availableSync: boolean
  onSubmit?: () => void
}

export function BlockingIssuesModal({
  onClose,
  blockingIssues,
  availableSync,
  onSubmit,
}: BlockingIssuesModalProps) {
  const { capabilityMode } = usePrivateIntegrationsSyncContext()
  const isExportMode = capabilityMode === 'file'

  const submitLabel = isExportMode
    ? i18n.t('integrations.confirmation_modal.export_anyway_cta')
    : i18n.t('integrations.confirmation_modal.sync_anyway_cta')

  return (
    <Modal
      illustration="upload"
      title={i18n.t('compensations.integrations.sync_validations.blocking_issues.modal_title')}
      onClose={onClose}
      footer={
        availableSync && onSubmit ? (
          <>
            <F0Button onClick={onClose} variant="outline" label={i18n.t('integrations.confirmation_modal.cancel_cta')} />
            <F0Button onClick={onSubmit} variant="default" label={submitLabel} />
          </>
        ) : undefined
      }
    >
      <Box gap="s32" width="s600">
        {blockingIssues.map((issue, index) => (
          <BlockingIssuesCallout blockingIssue={issue} key={index} />
        ))}
      </Box>
    </Modal>
  )
}
